import { createFocusTrap } from 'focus-trap';
import { add, listen, qs, qsa, remove } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { updateFilters } from '@/lib/filters/events';

import priceRange from '@/lib/filters/price-range';

const sel = {
  filter: '[data-filter-open]',
  flyouts: '[data-filter-flyout]',
  button: '[data-button]',
  wash: '[data-filter-wash]',
  tag: '[data-tag]',
  sort: '[data-sort]',
  close: '[data-close-icon]',
  form: '[data-filter-form-flyout]',
  priceRange: '[data-price-range]',
};

const selectors = {
  active: 'active',
  checked: ':checked',
};

export default node => {
  const flyoutForm = qs(sel.form, node);
  const flyouts = qsa(sel.flyouts, node);
  const wash = qs(sel.wash, node);
  let focusTrap = null;

  let range = null;
  const rangeContainer = qs(sel.priceRange, flyoutForm);

  if (rangeContainer) {
    range = priceRange(rangeContainer);
  }

  const events = [
    listen(qsa(sel.filter, node), 'click', clickFlyoutTrigger),
    listen(wash, 'click', clickWash),
    listen(qsa(sel.button, node), 'click', clickButton),
    listen(qsa(sel.close, node), 'click', clickWash),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) clickWash();
    }),
  ];

  function clickFlyoutTrigger(e) {
    e.preventDefault();
    const { filterOpen } = e.currentTarget.dataset;
    const drawer = qs(`[data-filter-flyout="${filterOpen}"]`, node);

    if (drawer) {
      focusTrap = createFocusTrap(drawer, { allowOutsideClick: true });
      drawer.setAttribute('aria-hidden', 'false');

      add(wash, selectors.active);
      add(drawer, selectors.active);
      focusTrap.activate();
      disableBodyScroll(node, {
        allowTouchMove: el => {
          while (el && el !== document.body) {
            if (el.getAttribute('data-scroll-lock-ignore') !== null) {
              return true;
            }
            el = el.parentNode;
          }
        },
        reserveScrollBarGap: true,
      });
    }
  }

  function clickWash(e) {
    e && e.preventDefault();

    focusTrap && focusTrap.deactivate();

    flyouts.forEach(flyout => flyout.setAttribute('aria-hidden', 'true'));

    remove([...flyouts, wash], selectors.active);
    enableBodyScroll(node);
  }

  function clickButton(e) {
    e.preventDefault();
    const { button } = e.currentTarget.dataset;

    const scope = e.currentTarget.closest(sel.flyouts);

    if (button === 'clear') {
      const inputs = qsa('[data-filter-item]', scope);
      inputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });
      removeRange();
    } else if (button === 'apply') {
      updateFilters(flyoutForm);
      clickWash();
    }
  }

  function removeRange() {
    range && range.reset();
  }

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
    range && range.unload();
  };

  return { unload };
};
